import { render, staticRenderFns } from "./DebtCollectionInputForm.vue?vue&type=template&id=8c18d442&"
import script from "./DebtCollectionInputForm.vue?vue&type=script&lang=js&"
export * from "./DebtCollectionInputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports